export default __webpack_public_path__ + "static/media/rightArrowCircle.3b6e9057.svg";